import React, { useEffect, useContext } from "react";
import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { 
    Save,
    TimerOff,
} from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { GetVisitTimeInfoSpecific } from "../utils/GetCustomer";
import { PostVisitPlan } from "../utils/PostCustomer";
import { useLocalStorage } from "../componentUtils/LocalStorage";
import { DisplayRoleContext } from "src/Context_api";

const VP_PREF:  string = "PREF";

interface CustomerRouteParams {
  identifier: string;
}

interface VisitState {
  isLoaded: boolean,
  isModified: string[],
  visitTimes: any,
  salesDays: Days,
  suspensionWindow?: {validFromDt:string, validToDt:string},
  VisitPlanMode: string;
}

interface Days {
  sun: boolean,
  mon: boolean,
  tue: boolean,
  wed: boolean,
  thu: boolean,
  fri: boolean,
  sat: boolean
}
const disabledDays:Days={sun: false,mon: false,tue: false,wed: false,thu: false,fri: false,sat: false}

function formatDate(date:Date) {
  var d = new Date(date),
      month = '' + (d.getUTCMonth() + 1),
      day = '' + d.getUTCDate(),
      year = d.getUTCFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    divWidth: {
      width: "100%",
    },
    chipActual: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2)
    },    
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    secMarginTop: {
      marginTop: theme.spacing(5),
    },
  })
);

export default function VisitInfo() {
  const routeParams = useParams<CustomerRouteParams>();
  const classes = useStyles();
  const theme = useTheme();
  const {isDisplayOnlyRole}: any = useContext(DisplayRoleContext)
  const [state, setState] = React.useState<VisitState>({
    isLoaded: false,
    isModified: [],
    visitTimes: [],
    salesDays: {sun: true, mon: true, tue: true, wed: true, thu: true, fri: true, sat: true},
    VisitPlanMode: "",
  });
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [alertDisplay, setAlertDisplay] = React.useState(false);

  const updateData = (v: any) => {
    //console.log(v);
    if (v.visitTimes) {
      var salesDays:Days = {sun: true, mon: true, tue: true, wed: true, thu: true, fri: true, sat: true};
      var suspensionWindow:{validFromDt:string, validToDt:string}|undefined;
      const sDays = v.visitTimes.find((item:any) => item.planType === 'S');
      if (sDays) {
        salesDays = {sun: sDays.sun, mon: sDays.mon, tue: sDays.tue, wed: sDays.wed, thu: sDays.thu, fri: sDays.fri, sat: sDays.sat};
      }
      const xDays = v.visitTimes.find((item:any) => item.planType === 'X');
      if (xDays){
        suspensionWindow = {validFromDt:xDays.validFromDt, validToDt:xDays.validToDt}
      }

      let vpm=""

      if(v.config){
        vpm = v.config?.param_value || ""
      }

      setState({
        ...state,
        isLoaded: true,
        visitTimes: v.visitTimes,
        salesDays,
        suspensionWindow,
        isModified: [],
        VisitPlanMode:vpm,
      });
    }
  }

  useEffect(() => {
    if (state.isLoaded) return;

    GetVisitTimeInfoSpecific(salesOrg.toString(), routeParams.identifier).then((v: any) => updateData(v));
  }, [state, routeParams.identifier]);

  if (!state.isLoaded)
    return <div>Loading...</div>;

    const visitPlan = state.visitTimes.find((item:any) => item.planType === 'P');
    const numberOfdays = state.visitTimes.find((item:any) => item.planType === 'L');
    const fixedSchd = state.visitTimes.find((item:any) => item.planType === 'F');

    const handleSalesDaysChange = (event:any) => {
      event.persist();
      if(state.salesDays){
        var salesDays:Days = state.salesDays;
        salesDays[event.target.name as keyof Days] = event.target.checked;
        setState({
          ...state,
          salesDays: salesDays,
          isModified: state.isModified.concat(['S'])
        });
      }
    }

    const handleSuspensionChange = (event:any, field:'validFromDt'|'validToDt') => {
      event.persist();
      
      var suspensionWindow = {
        validFromDt:formatDate(new Date()),
        validToDt:'9999-01-01',
        ...state.suspensionWindow,
      };
      suspensionWindow[field]=event.target.value
      setState({
        ...state,
        suspensionWindow: suspensionWindow,
        isModified: state.isModified.concat(['X'])
      });
    }

      const handleSave = (event:any) => {
        const customerNum = routeParams.identifier;
        let data:{save:any[]} = {save:[]};
        if(state.isModified.findIndex(m=> m === 'S') >=0) {
          data.save.push({clientId:100, salesOrg, customerNum, planType: `S`, frequency: 0, ...state.salesDays });
        }
        if(state.isModified.findIndex(m=> m === 'X') >=0) {
          let from:any=state.suspensionWindow?.validFromDt
          let to:any=state.suspensionWindow?.validToDt
          let fromDt=new Date(from);
          let toDt=new Date(to);

          if (fromDt<=toDt) {
            data.save.push({clientId:100, salesOrg, customerNum, planType: `X`, ...disabledDays, frequency: 0, ...state.suspensionWindow });
          }else{
            setAlertDisplay(true);
          }
        }
       // console.log(state.isModified)
        PostVisitPlan(salesOrg.toString(), routeParams.identifier, data).then((v: any) => updateData(v));
    }

  return (
    <div className={classes.root}>
      {fixedSchd ?
        <Chip
          label="Fixed Schedule"
          className={classes.chipActual}
          color="primary"
        />
      :
        <Chip
          label="Dynamic Schedule"
          className={classes.chipActual}
          color="primary"
        />
      }
      {(state.suspensionWindow && state.suspensionWindow.validFromDt <= formatDate(new Date())  && state.suspensionWindow.validToDt >= formatDate(new Date()) )? 
        <Chip
            label="Suspension Schedule"
            icon={<TimerOff/>}
            className={classes.chipActual}
            color="primary"
          />:<div></div>}
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Plan Type</TableCell>
              <TableCell align="right">Frequency</TableCell>
              <TableCell align="right">Number of days</TableCell> 
              <TableCell align="right">Valid From</TableCell>
              <TableCell align="right">Valid To</TableCell>
              <TableCell align="right">Sun</TableCell>              
              <TableCell align="right">Mon</TableCell>           
              <TableCell align="right">Tue</TableCell>           
              <TableCell align="right">Wed</TableCell>           
              <TableCell align="right">Thu</TableCell>           
              <TableCell align="right">Fri</TableCell>           
              <TableCell align="right">Sat</TableCell>           
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Sales Office Operations</TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"><Checkbox disabled checked={false}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={true}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={true}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={true}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={true}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={true}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={false}/></TableCell>
            </TableRow>
            { visitPlan &&
              <TableRow>
              <TableCell>{ `${(VP_PREF !== state.VisitPlanMode)?('Access Days / '):('')}SAP Visit Plan`}</TableCell>
              <TableCell align="right">{visitPlan.frequency}</TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right">{visitPlan.validFromDt}</TableCell>
              <TableCell align="right">{visitPlan.validToDt}</TableCell>
              <TableCell align="right"><Checkbox disabled checked={visitPlan.sun}/></TableCell>
              <TableCell align="right"><Checkbox disabled checked={visitPlan.mon}/></TableCell>                         
              <TableCell align="right"><Checkbox disabled checked={visitPlan.tue}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={visitPlan.wed}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={visitPlan.thu}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={visitPlan.fri}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={visitPlan.sat}/></TableCell>
            </TableRow>
            }
            { numberOfdays &&
            <TableRow>
              <TableCell>Fixed Schedule</TableCell>
              <TableCell align="right">{numberOfdays.frequency}</TableCell>
              <TableCell align="right">{numberOfdays.number_of_days}</TableCell>
              <TableCell align="right">{numberOfdays.validFromDt}</TableCell>
              <TableCell align="right">{numberOfdays.validToDt}</TableCell>
              <TableCell align="right"><Checkbox disabled checked={numberOfdays.sun}/></TableCell>
              <TableCell align="right"><Checkbox disabled checked={numberOfdays.mon}/></TableCell>                         
              <TableCell align="right"><Checkbox disabled checked={numberOfdays.tue}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={numberOfdays.wed}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={numberOfdays.thu}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={numberOfdays.fri}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={numberOfdays.sat}/></TableCell>
            </TableRow>
            }
            { fixedSchd &&
            <TableRow>
              <TableCell>Fixed Schedule</TableCell>
              <TableCell align="right">{fixedSchd.frequency}</TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right">{fixedSchd.validFromDt}</TableCell>
              <TableCell align="right">{fixedSchd.validToDt}</TableCell>
              <TableCell align="right"><Checkbox disabled checked={fixedSchd.sun}/></TableCell>
              <TableCell align="right"><Checkbox disabled checked={fixedSchd.mon}/></TableCell>                         
              <TableCell align="right"><Checkbox disabled checked={fixedSchd.tue}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={fixedSchd.wed}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={fixedSchd.thu}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={fixedSchd.fri}/></TableCell>           
              <TableCell align="right"><Checkbox disabled checked={fixedSchd.sat}/></TableCell>
            </TableRow>
            }
            
            <TableRow>
              <TableCell>Sales Days</TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"><Checkbox disabled={isDisplayOnlyRole} name="sun" onChange={handleSalesDaysChange} checked={state.salesDays.sun}/></TableCell>
              <TableCell align="right"><Checkbox disabled={isDisplayOnlyRole} name="mon" onChange={handleSalesDaysChange} checked={state.salesDays.mon}/></TableCell>                         
              <TableCell align="right"><Checkbox disabled={isDisplayOnlyRole} name="tue" onChange={handleSalesDaysChange} checked={state.salesDays.tue}/></TableCell>           
              <TableCell align="right"><Checkbox disabled={isDisplayOnlyRole} name="wed" onChange={handleSalesDaysChange} checked={state.salesDays.wed}/></TableCell>           
              <TableCell align="right"><Checkbox disabled={isDisplayOnlyRole} name="thu" onChange={handleSalesDaysChange} checked={state.salesDays.thu}/></TableCell>           
              <TableCell align="right"><Checkbox disabled={isDisplayOnlyRole} name="fri" onChange={handleSalesDaysChange} checked={state.salesDays.fri}/></TableCell>           
              <TableCell align="right"><Checkbox disabled={isDisplayOnlyRole} name="sat" onChange={handleSalesDaysChange} checked={state.salesDays.sat}/></TableCell>
            </TableRow> 

          <TableRow>
            <TableCell>Suspension Window</TableCell>
            <TableCell align="right"></TableCell>
            <TableCell align="right"></TableCell>
            <TableCell align="right"><TextField disabled={isDisplayOnlyRole} fullWidth={false} type="date" value={state.suspensionWindow?.validFromDt} onChange={(ce)=>handleSuspensionChange(ce,'validFromDt')}/></TableCell>
            <TableCell align="right"><TextField disabled={isDisplayOnlyRole} fullWidth={false} type="date" value={state.suspensionWindow?.validToDt} onChange={(ce)=>handleSuspensionChange(ce,'validToDt')}/></TableCell>
            <TableCell align="right"><Checkbox disabled checked={false}/></TableCell>
            <TableCell align="right"><Checkbox disabled checked={false}/></TableCell>
            <TableCell align="right"><Checkbox disabled checked={false}/></TableCell>
            <TableCell align="right"><Checkbox disabled checked={false}/></TableCell>
            <TableCell align="right"><Checkbox disabled checked={false}/></TableCell>
            <TableCell align="right"><Checkbox disabled checked={false}/></TableCell>
            <TableCell align="right"><Checkbox disabled checked={false}/></TableCell>
          </TableRow>  
          </TableBody>
        </Table>
      </TableContainer>
      <Grid container spacing={2} direction="row-reverse" className={classes.gridMarginTop}>
        <Grid item xs={1} lg={1} className={classes.gridSpaceable}>
          <Button
            color="primary"
            variant="contained"
            disabled={ isDisplayOnlyRole || state.isModified.length === 0}
            onClick={handleSave} >
            <Save /> Save
          </Button>
        </Grid>

      </Grid>
      <Dialog fullWidth={true} maxWidth="md" aria-labelledby="dri-title" open={alertDisplay} onClose={()=>{setAlertDisplay(false)}}>
        <DialogTitle id="dri-title">Alert</DialogTitle>
        <DialogContent style={{color:'red',fontWeight:'bolder'}}>
          From date should not be greater than To date, Please Validate From and To Date!
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{setAlertDisplay(false)}} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
